export const ANIMATION_CONSTANTS = {
  FLOWER_ANIMATION_INTERVAL: 200,
  REDIRECT_DELAY: 2000,
  TOTAL_FLOWERS: 4,
} as const

export const PLACEHOLDER_DATA = {
  DESIGNER_COUNT: 1000,
  WEDDING_COUNT: 5000,
} as const
